<button
  (click)="onClick(eEventType.ALIGN_CONTENT_VERTICALLY)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="Align Content Vertically"
  matTooltipPosition="below"
>
  <mat-icon>align_horizontal_center</mat-icon>
</button>
<button
  (click)="onClick(eEventType.TOGGLE_CONTENT_VIEW)"
  class="e-flow-panel-button"
  mat-icon-button
  [matTooltip]="isContentMinimized ? 'Expand Content' : 'Minimize Content'"
  matTooltipPosition="below"
>
  <mat-icon>{{ isContentMinimized ? 'unfold_more' : 'unfold_less' }}</mat-icon>
</button>
<button
  (click)="onClick(eEventType.DELETE_SELECTED)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="Delete"
  matTooltipPosition="below"
>
  <mat-icon>delete</mat-icon>
</button>
<button
  (click)="onClick(eEventType.SELECT_ALL)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="Select All"
  matTooltipPosition="below"
>
  <mat-icon>select_all</mat-icon>
</button>
<!--<button (click)="onClick(eEventType.TEST_CALL)" class="e-flow-panel-button" mat-icon-button matTooltip="Test Call"
        matTooltipPosition="below">
  <mat-icon>call_log</mat-icon>
</button>-->

<button
  (click)="onClick(eEventType.ZOOM_IN)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="Zoom In"
  matTooltipPosition="below"
>
  <mat-icon>zoom_in</mat-icon>
</button>
<button
  (click)="onClick(eEventType.ZOOM_OUT)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="Zoom Out"
  matTooltipPosition="below"
>
  <mat-icon>zoom_out</mat-icon>
</button>
<button
  (click)="onClick(eEventType.FIT_TO_SCREEN)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="Fit to Screen"
  matTooltipPosition="below"
>
  <mat-icon>zoom_in_map</mat-icon>
</button>
<button
  (click)="onClick(eEventType.ONE_TO_ONE)"
  class="e-flow-panel-button"
  mat-icon-button
  matTooltip="1:1"
  matTooltipPosition="below"
>
  <mat-icon>center_focus_strong</mat-icon>
</button>
